export default __webpack_public_path__ + "static/media/holidays-banner.f6280669.webp";